import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { loggedUserIdSelector } from '../../redux/context/selectors';

const useGetHaveInsuranceLabel = ({
  formatMessage,
  targetUserName,
  targetUserId,
  withSelfPayEnding = true,
}) => {
  const loggedUserId = useSelector(loggedUserIdSelector);

  const isLoggedUser = loggedUserId === targetUserId;

  const label = useMemo(() => {
    if (isLoggedUser) {
      return formatMessage({ id: 'fields.insurance.haveNotInsurance' });
    }
    return formatMessage(
      { id: 'fields.insurance.patientHaveNotInsurance' },
      { name: targetUserName },
    );
  }, [isLoggedUser, targetUserName]);

  return withSelfPayEnding
    ? `${label} ${formatMessage({ id: 'general.labels.or' })} ${formatMessage({
        id: 'common.selfPay',
      })}`
    : label;
};

export default useGetHaveInsuranceLabel;



// WEBPACK FOOTER //
// ./src/hooks/patientInsurance/useGetHaveInsuranceLabel.js